/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddPublicationDate } from './add-publication-date';

export interface PublishLetterBatch {
  seasonId: string;
  seasonType?: PublishLetterBatchSeasonTypeEnum | null;
  letterType: PublishLetterBatchLetterTypeEnum;
  workflowId?: string;
  managerType?: PublishLetterBatchManagerTypeEnum | null;
  employeeTaskTemplateId?: string | null;
  employeeMailTemplateId?: string | null;
  managerTaskTemplateId?: string | null;
  managerMailTemplateId?: string | null;
  hrBusinessPartnerMailTemplateId?: string | null;
  overridenPublicationDates?: Array<AddPublicationDate> | null;
}
export enum PublishLetterBatchSeasonTypeEnum {
  Unknown = 'Unknown',
  Sog = 'SOG',
  Gbr = 'GBR',
  Merit = 'Merit',
  IncentiveV2 = 'IncentiveV2',
  SpecialPaymentCash = 'SpecialPaymentCash',
  SpecialPaymentEquity = 'SpecialPaymentEquity',
  PositionEvaluation = 'PositionEvaluation',
  Restructuring = 'Restructuring'
}
export enum PublishLetterBatchLetterTypeEnum {
  Other = 'Other',
  AdherenceLetter = 'AdherenceLetter',
  TargetAgreementForm = 'TargetAgreementForm',
  TargetAchievementForm = 'TargetAchievementForm',
  MeritAllocation = 'MeritAllocation',
  SpecialRecognitionLetter = 'SpecialRecognitionLetter',
  RestructuringCalculation = 'RestructuringCalculation',
  RestructuringLetter = 'RestructuringLetter'
}
export enum PublishLetterBatchManagerTypeEnum {
  LineManager = 'LineManager',
  CompanyManager = 'CompanyManager',
  None = 'None'
}
